import { render, staticRenderFns } from "./MetacomTerms.vue?vue&type=template&id=5fbc57ad&scoped=true&lang=pug"
import script from "./MetacomTerms.vue?vue&type=script&lang=js"
export * from "./MetacomTerms.vue?vue&type=script&lang=js"
import style0 from "./MetacomTerms.vue?vue&type=style&index=0&id=5fbc57ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc57ad",
  null
  
)

export default component.exports